import React, { Component } from 'react';
import { connect } from 'react-redux'
import ParticlesContainer from '../dashboard/ParticlesContainer';
import { sendVerificationEmail } from '../../store/actions/authActions'
import { withRouter } from "react-router";
import M from 'materialize-css';
M.AutoInit();

const jumbotronStyle = {
  paddingBottom: '60px',
  paddingTop: '80px',
  boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",
  position: "relative",
  zIndex: "999",
}

const insideStyle = {
  position: "relative",
  zIndex: "999009",
}

class VerifyEmail extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  state = {
    sent: false
  }

  onClick = e => {
    let promise = Promise.resolve();
    promise
      .then(this.props.sendVerificationEmail())
      .then(this.setState({ sent: true }))
      .then(M.toast({ html: "Verification mail sent!", classes: 'rounded', displayLength: 8000 }))
  }



  render() {
    const sendbutton = this.state.sent ? <button className="btn teal lighten-1 z-depth-1" disabled>SEND AGAIN</button> : <button className="btn teal lighten-1 z-depth-1" onClick={this.onClick}>SEND AGAIN</button>
    return (
      <div className="grey lighten-5" >

        <div className="card-panel white-text teal lighten-1" style={jumbotronStyle}>
          <ParticlesContainer>
          </ParticlesContainer>
          <div className="container white-text" style={insideStyle}>
            <h4>Email Verification needed</h4>
          </div>
        </div>

        <div className="mainpage container z-depth-0 ">
          <div className="row">
          </div>

          <div className="row">
            Please check your inbox and verify the cusaly account.
          </div>



          <div className="row">
            Can't find verification email?
          </div>
          {sendbutton}
        </div>
      </div >
    )
  }
}

// export default withRouter(VerifyEmail);

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendVerificationEmail: () => dispatch(sendVerificationEmail())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyEmail));